export const wrapTex = {
  "F364686-000038": {
    repeat_x: 40,
    repeat_y: 40,
  },
  "F338608-000015": {
    repeat_x: 183,
    repeat_y: 833,
  },
  "Savoy-242": {
    repeat_x: 473,
    repeat_y: 173,
  },
  "F3101726-000021": {
    repeat_x: 113,
    repeat_y: 113,
  },
  "F323378-000013": {
    repeat_x: 703,
    repeat_y: 723,
  },
  "F323378-000017": {
    repeat_x: 703,
    repeat_y: 703,
  },
  "F311790-000013": {
    repeat_x: 193,
    repeat_y: 193,
  },
  "F311790-000019": {
    repeat_x: 193,
    repeat_y: 193,
  },
  "F333330-000013": {
    repeat_x: 360,
    repeat_y: 883,
  },
  "F333330-000019": {
    // test tessuto reale
    repeat_x: 360,
    repeat_y: 1083,
  },
  "F333330-000036": {
    repeat_x: 350,
    repeat_y: 883,
  },
  "F338608-000013": {
    repeat_x: 163,
    repeat_y: 833,
  },

  "F338608-000018": {
    // test tessuto reale
    repeat_x: 163,
    repeat_y: 1033,
  },
  "F338608-000039": {
    repeat_x: 163,
    repeat_y: 833,
  },
  "F338608-000085": {
    repeat_x: 163,
    repeat_y: 833,
  },
  "F333334-000013": {
    repeat_x: 103,
    repeat_y: 1563,
  },
  "F333334-000019": {
    repeat_x: 103,
    repeat_y: 1563,
  },
  "F333334-000110": {
    repeat_x: 103,
    repeat_y: 1763,
  },
  "F333853-000001": {
    repeat_x: 483,
    repeat_y: 483,
  },
  "F333853-000015": {
    repeat_x: 183,
    repeat_y: 183,
  },
  "F333853-000017": {
    repeat_x: 1183,
    repeat_y: 1183,
  },
  "F336070-000001": {
    repeat_x: 183,
    repeat_y: 183,
  },
  "F336070-000015": {
    repeat_x: 883,
    repeat_y: 883,
  },
  "F336070-000017": {
    repeat_x: 883,
    repeat_y: 883,
  },
  "F336072-000001": {
    repeat_x: 1033,
    repeat_y: 1033,
  },
  "F364689-000019": {
    repeat_x: 38,
    repeat_y: 38,
  },

  "F369841-000031": {
    repeat_x: 60,
    repeat_y: 60,
  },
  "F369842-000061": {
    repeat_x: 65,
    repeat_y: 65,
  },
  "F342657-000001": {
    repeat_x: 283,
    repeat_y: 283,
  },
  "F342657-000015": {
    repeat_x: 1083,
    repeat_y: 1083,
  },
  "F342657-000049": {
    repeat_x: 1283,
    repeat_y: 1283,
  },

  "F332475-000001": {
    repeat_x: 583,
    repeat_y: 583,
  },
  "F332475-000103": {
    repeat_x: 953,
    repeat_y: 953,
  },
  "F332475-000012": {
    repeat_x: 953,
    repeat_y: 953,
  },
  "Savoy-24": {
    repeat_x: 1833,
    repeat_y: 1833,
  },
  "Savoy-36": {
    repeat_x: 233,
    repeat_y: 983,
  },
  "Savoy-72": {
    repeat_x: 226,
    repeat_y: 453,
  },
  "Savoy-108": {
    repeat_x: 226,
    repeat_y: 283,
  },
  "Savoy-116": {
    repeat_x: 563,
    repeat_y: 493,
  },
  "Savoy-117": {
    repeat_x: 563,
    repeat_y: 803,
  },
  "Savoy-120": {
    repeat_x: 223,
    repeat_y: 1053,
  },
  "Savoy-121": {
    repeat_x: 223,
    repeat_y: 683,
  },
  "Savoy-122": {
    repeat_x: 233,
    repeat_y: 883,
  },
  "Savoy-123": {
    repeat_x: 233,
    repeat_y: 983,
  },
  "Savoy-179": {
    repeat_x: 563,
    repeat_y: 713,
  },

  "Savoy-243": {
    repeat_x: 473,
    repeat_y: 573,
  },
  "Savoy-246": {
    repeat_x: 193,
    repeat_y: 173,
  },
  "Savoy-248": {
    repeat_x: 226,
    repeat_y: 1383,
  },
  "Savoy-249": {
    repeat_x: 226,
    repeat_y: 1383,
  },
  "Savoy-250": {
    repeat_x: 226,
    repeat_y: 1383,
  },
  "Savoy-251": {
    repeat_x: 226,
    repeat_y: 1383,
  },
  "Savoy-308": {
    repeat_x: 953,
    repeat_y: 953,
  },
  "Savoy-309": {
    repeat_x: 953,
    repeat_y: 953,
  },
  "Savoy-310": {
    repeat_x: 1533,
    repeat_y: 1533,
  },
  "Savoy-324": {
    repeat_x: 530,
    repeat_y: 1270,
  },
  "Cobra-263": {
    repeat_x: 673,
    repeat_y: 623,
  },
  "Cobra-266": {
    repeat_x: 673,
    repeat_y: 623,
  },
  "Cobra-341": {
    repeat_x: 733,
    repeat_y: 533,
  },
  "Cobra-342": {
    repeat_x: 733,
    repeat_y: 533,
  },
  "Cobra-343": {
    repeat_x: 733,
    repeat_y: 533,
  },
  "Cobra-346": {
    repeat_x: 733,
    repeat_y: 533,
  },
  "Cobra-353": {
    repeat_x: 793,
    repeat_y: 793,
  },
  "Cobra-354": {
    repeat_x: 793,
    repeat_y: 793,
  },
  "Iris-P12707-30": {
    repeat_x: 83,
    repeat_y: 83,
  },
  "Iris-P12707-31": {
    repeat_x: 823,
    repeat_y: 823,
  },
  "Iris-P12707-32": {
    repeat_x: 83,
    repeat_y: 83,
  },
  "Iris-P12707-33": {
    repeat_x: 863,
    repeat_y: 563,
  },
  "Iris-P12707-34": {
    repeat_x: 83,
    repeat_y: 83,
  },
  "Iris-P12707-60": {
    repeat_x: 1083,
    repeat_y: 683,
  },
  "Iris-P12707-61": {
    repeat_x: 83,
    repeat_y: 83,
  },
  "CHELSEA-P46747-03": {
    repeat_x: 583,
    repeat_y: 583,
  },
  "CHELSEA-P46747-10": {
    repeat_x: 1533,
    repeat_y: 1533,
  },
  "CHELSEA-P46747-15": {
    repeat_x: 83,
    repeat_y: 83,
  },
  "CHELSEA-P46747-20": {
    repeat_x: 83,
    repeat_y: 83,
  },
  "CHELSEA-P46747-1000": {
    repeat_x: 833,
    repeat_y: 833,
  },

  "2317H-W21363-0001": {
    repeat_x: 83,
    repeat_y: 83,
  },
  "2317H-W21367-0001": {
    repeat_x: 213,
    repeat_y: 213,
  },
  "2317H-W21500-0002": {
    repeat_x: 523,
    repeat_y: 523,
  },
  "2317H-W21501-0002": {
    repeat_x: 383,
    repeat_y: 483,
  },
  "2317H-W21502-0002": {
    repeat_x: 183,
    repeat_y: 183,
  },
  "2317H-W21505-0001": {
    repeat_x: 483,
    repeat_y: 483,
  },
  "2317H-W21506-0001": {
    repeat_x: 163,
    repeat_y: 163,
  },
  "2317H-W21508-0001": {
    repeat_x: 53,
    repeat_y: 63,
  },
  "2317H-W21518-0007": {
    repeat_x: 153,
    repeat_y: 153,
  },
  "2317H-W21527-0005": {
    repeat_x: 353,
    repeat_y: 353,
  },
  "2317H-W21774-0001": {
    repeat_x: 323,
    repeat_y: 323,
  },
  "2317H-W21772-0004": {
    repeat_x: 323,
    repeat_y: 323,
  },
  "2317H-W21777-0005": {
    repeat_x: 303,
    repeat_y: 303,
  },
  "2317H-W21778-0001": {
    repeat_x: 393,
    repeat_y: 393,
  },
  "2317H-W21780-0001": {
    repeat_x: 293,
    repeat_y: 293,
  },
  "2317H-W21781-0001": {
    repeat_x: 253,
    repeat_y: 253,
  },
  "2317H-W21781-0005": {
    repeat_x: 253,
    repeat_y: 253,
  },
  "2317H-W21782-0004": {
    repeat_x: 223,
    repeat_y: 223,
  },
  "2317H-W21963-0007": {
    repeat_x: 83,
    repeat_y: 83,
  },
  "2317H-W21964-0007": {
    repeat_x: 223,
    repeat_y: 223,
  },
  "2317H-W21966-0005": {
    repeat_x: 163,
    repeat_y: 163,
  },
  "2317H-W21970-0005": {
    repeat_x: 133,
    repeat_y: 113,
  },
  "2317H-W21984-0006": {
    repeat_x: 183,
    repeat_y: 183,
  },
  "2317H-W21985-0006": {
    repeat_x: 383,
    repeat_y: 383,
  },
  "2317H-W21986-0006": {
    repeat_x: 153,
    repeat_y: 153,
  },
  "2317H-W22984-0007": {
    repeat_x: 183,
    repeat_y: 263,
  },
  "2317H-W22985-0007": {
    repeat_x: 213,
    repeat_y: 453,
  },
  "2317H-W22993-0001": {
    repeat_x: 133,
    repeat_y: 143,
  },

  "2317H-W22994-0001": {
    repeat_x: 83,
    repeat_y: 83,
  },
  "2317H-W22995-0001": {
    repeat_x: 183,
    repeat_y: 183,
  },
  "2317H-W22996-0001": {
    repeat_x: 33,
    repeat_y: 43,
  },
  "2317H-W22997-0001": {
    repeat_x: 223,
    repeat_y: 393,
  },
  "2317H-W22998-0001": {
    repeat_x: 33,
    repeat_y: 63,
  },
  "2317H-W22999-0001": {
    repeat_x: 133,
    repeat_y: 133,
  },
  "2317H-W23000-0001": {
    repeat_x: 233,
    repeat_y: 263,
  },
  "2317H-W23001-0001": {
    repeat_x: 193,
    repeat_y: 263,
  },
  "2317H-W23003-0001": {
    repeat_x: 193,
    repeat_y: 243,
  },
  "2317H-W23004-0001": {
    repeat_x: 133,
    repeat_y: 133,
  },
  "2317H-W23006-0001": {
    repeat_x: 273,
    repeat_y: 273,
  },
  "2317H-W24081-0001": {
    repeat_x: 273,
    repeat_y: 233,
  },
  "2317H-W24083-0001": {
    repeat_x: 183,
    repeat_y: 143,
  },
  "2317H-W24086-0001": {
    repeat_x: 233,
    repeat_y: 233,
  },
  "2317H-W24087-0001": {
    repeat_x: 83,
    repeat_y: 143,
  },
  "2317H-W24088-0001": {
    repeat_x: 163,
    repeat_y: 163,
  },
  "2317H-W24089-0001": {
    repeat_x: 163,
    repeat_y: 293,
  },
  "2317H-W24091-0001": {
    repeat_x: 103,
    repeat_y: 193,
  },
  "2317H-W24092-0001": {
    repeat_x: 183,
    repeat_y: 103,
  },
  "2317H-W24097-0001": {
    repeat_x: 113,
    repeat_y: 113,
  },
  "2317H-W24098-0001": {
    repeat_x: 173,
    repeat_y: 103,
  },
  "2317H-W24100-0001": {
    repeat_x: 183,
    repeat_y: 196,
  },
  "2317H-W24101-0001": {
    repeat_x: 163,
    repeat_y: 163,
  },
  "2317H-W24275-0001": {
    repeat_x: 123,
    repeat_y: 123,
  },
  "2317H-W24392-0001": {
    repeat_x: 213,
    repeat_y: 213,
  },
  "2317H-W24409-0001": {
    repeat_x: 83,
    repeat_y: 83,
  },
  "2317H-W24634-0001": {
    repeat_x: 243,
    repeat_y: 243,
  },
  "2317H-W24636-0001": {
    repeat_x: 133,
    repeat_y: 83,
  },
  "2317H-W24651-0001": {
    repeat_x: 73,
    repeat_y: 38,
  },
  "2317H-W24678-0002": {
    repeat_x: 110,
    repeat_y: 110,
  },
  "2317H-W24682-0002": {
    repeat_x: 13,
    repeat_y: 18,
  },
  "2317H-W24715-0001": {
    repeat_x: 2,
    repeat_y: 2,
  },
  "2317H-W25056-0001": {
    repeat_x: 353,
    repeat_y: 353,
  },

  "2317H-W21774-0004": {
    repeat_x: 323,
    repeat_y: 323,
  },
  "2317H-W21776-0001": {
    repeat_x: 13,
    repeat_y: 23,
  },
  "2317H-W22992-0001": {
    repeat_x: 133,
    repeat_y: 143,
  },

  "F338521-000011": {
    repeat_x: 633,
    repeat_y: 1683,
  },
  "F312849-000015": {
    repeat_x: 1153,
    repeat_y: 1153,
  },
  "F336072-000012": {
    repeat_x: 883,
    repeat_y: 883,
  },
  "F336072-000013": {
    repeat_x: 1083,
    repeat_y: 1083,
  },
  "F336072-000035": {
    repeat_x: 1153,
    repeat_y: 1153,
  },
  "F3400863-000015": {
    repeat_x: 593,
    repeat_y: 1283,
  },
  "F359289-000015": {
    repeat_x: 273,
    repeat_y: 943,
  },
  "F3400867-000035": {
    repeat_x: 103,
    repeat_y: 923,
  },
  "F366170-000015": {
    repeat_x: 23,
    repeat_y: 23,
  },
  "F366173-000035": {
    repeat_x: 23,
    repeat_y: 23,
  },
  "F366176-000035": {
    repeat_x: 26,
    repeat_y: 26,
  },
  "F366177-000065": {
    repeat_x: 23,
    repeat_y: 23,
  },
  "F364683-000058": {
    repeat_x: 13,
    repeat_y: 13,
  },
  "F364684-000057": {
    repeat_x: 20,
    repeat_y: 20,
  },
  "F3101726-000031": {
    repeat_x: 130,
    repeat_y: 130,
  },
  "F3101726-000051": {
    repeat_x: 130,
    repeat_y: 130,
  },
  "F367352-000025": {
    repeat_x: 103,
    repeat_y: 103,
  },
  "F367352-000035": {
    repeat_x: 73,
    repeat_y: 73,
  },
  "F367352-000055": {
    repeat_x: 73,
    repeat_y: 73,
  },

  "R38116-50436": {
    repeat_x: 83,
    repeat_y: 83,
  },
  "P64941-1000": {
    repeat_x: 883,
    repeat_y: 1183,
  },
  "P64941-01": {
    repeat_x: 83,
    repeat_y: 83,
  },
  "P64941-02": {
    repeat_x: 3,
    repeat_y: 3,
  },
  "P66461-01": {
    repeat_x: 283,
    repeat_y: 643,
  },
  "P66462-01": {
    repeat_x: 253,
    repeat_y: 253,
  },
  "P64957-01": {
    repeat_x: 443,
    repeat_y: 483,
  },
  "P66456-01": {
    repeat_x: 243,
    repeat_y: 683,
  },
  "P66457-01": {
    repeat_x: 183,
    repeat_y: 483,
  },
  "P66458-01": {
    repeat_x: 123,
    repeat_y: 583,
  },
  "P64957-02": {
    repeat_x: 443,
    repeat_y: 483,
  },
  "P66456-03": {
    repeat_x: 243,
    repeat_y: 683,
  },
  "P66457-02": {
    repeat_x: 183,
    repeat_y: 483,
  },
  "P58524-1000": {
    repeat_x: 883,
    repeat_y: 883,
  },
  "P58524-02": {
    repeat_x: 953,
    repeat_y: 953,
  },
  "P58524-01": {
    repeat_x: 953,
    repeat_y: 953,
  },
  "P58509-1000": {
    repeat_x: 583,
    repeat_y: 583,
  },
  "F61691-1000": {
    repeat_x: 883,
    repeat_y: 883,
  },
  "F61691-05": {
    repeat_x: 983,
    repeat_y: 983,
  },
  "P46875-1000": {
    repeat_x: 583,
    repeat_y: 583,
  },
  "P46875-04": {
    repeat_x: 1153,
    repeat_y: 1153,
  },
  "P46875-05": {
    repeat_x: 953,
    repeat_y: 953,
  },
  "P46875-06": {
    repeat_x: 953,
    repeat_y: 953,
  },
  "P24028-16": {
    repeat_x: 273,
    repeat_y: 583,
  },
  "P24028-33": {
    repeat_x: 83,
    repeat_y: 483,
  },
  "P38017-01": {
    repeat_x: 523,
    repeat_y: 963,
  },
  "P38017-02": {
    repeat_x: 523,
    repeat_y: 963,
  },
  "P38017-12": {
    repeat_x: 523,
    repeat_y: 983,
  },
  "P38017-13": {
    repeat_x: 523,
    repeat_y: 983,
  },
  "P38017-04": {
    repeat_x: 523,
    repeat_y: 983,
  },
  "P38017-05": {
    repeat_x: 523,
    repeat_y: 983,
  },
  "F313322-000013": {
    repeat_x: 353,
    repeat_y: 353,
  },
  "F313322-000017": {
    repeat_x: 353,
    repeat_y: 353,
  },
  "F313322-000036": {
    repeat_x: 353,
    repeat_y: 353,
  },
  "F3400769-000025": {
    repeat_x: 73,
    repeat_y: 433,
  },
  "F350687-000015": {
    repeat_x: 193,
    repeat_y: 1033,
  },
  "F354472-000017": {
    repeat_x: 110,
    repeat_y: 1433,
  },
  "F354473-000038": {
    repeat_x: 110,
    repeat_y: 1433,
  },
  "05854-00111": {
    repeat_x: 113,
    repeat_y: 113,
  },
  "17767-00001": {
    repeat_x: 533,
    repeat_y: 533, 
  },
  "17770-00001": {
    repeat_x: 533,
    repeat_y: 533,
  },
  "17814-00003": {
    repeat_x: 993,
    repeat_y: 993,
  },
  "18235-00003": {
    repeat_x: 993,
    repeat_y: 1193,  
  },
  "22086-00003": {
    repeat_x: 993,
    repeat_y: 1193,  
  },
  "31904-00001": {
    repeat_x: 216,
    repeat_y: 553,  
  },
  "31906-00001": {
    repeat_x: 216,
    repeat_y: 553, 
  },
  "N5854-09182": {
    repeat_x: 113,
    repeat_y: 113,  
  },
  "N5854-09187": {
    repeat_x: 993,
    repeat_y: 993,  
  },
  "N5854-09251": {
    repeat_x: 993,
    repeat_y: 993,  
  },
  "N5854-09265": {
    repeat_x: 993,
    repeat_y: 993,
  }
  };


export const wrapCont = {
  0: {
    repeat_x: 22,
    repeat_y: 22,
  },
  1: {
    repeat_x: 22,
    repeat_y: 22,
  },
  2: {
    repeat_x: 92,
    repeat_y: 92,
  },
  3: {
    repeat_x: 52,
    repeat_y: 52,
  },
};
